<template>
  <div class="match-invite-page">
    <Breadcrumb :type="1"></Breadcrumb>
    <div class="collaboration-content">
      <img
        src="@/assets/images/icon-25.png"
        v-if="categoryId == '139'"
        alt=""
        class="icon-image"
      />
      <img
        src="@/assets/images/icon-26.png"
        v-if="categoryId == '140'"
        alt=""
        class="icon-image"
      />
      <img
        src="@/assets/images/icon-27.png"
        v-if="categoryId == '141'"
        alt=""
        class="icon-image"
      />
      <div>
        <div
          class="company-row"
          v-for="(item, index) in newsList"
          :key="index"
          :class="index % 2 != 0 ? 'company-row-active' : ''"
        >
          <div class="company-image">
            <img class="image" :src="item.cover" alt="logo" />
          </div>
          <div class="company-flex"></div>
          <div class="company-message">
            <div class="message-title">
              {{ item.articleName }}
            </div>
            <div class="desc" v-html="item.articleContent"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getNavItemByCode } from '@/api/common/common.js'
import { getArticlePage } from '@/api/home/home.js'
import Breadcrumb from '@/components/common/breadcrumb'
export default {
  components: {
    Breadcrumb
  },
  data() {
    return {
      tabList: [],
      pageType: '', //1 文章内容，2 文章列表
      categoryId: '',
      tabcode: '',
      seccode: '',
      currentCategory: {
        categoryName: '',
        englishName: ''
      },
      newsList: []
    }
  },
  created() {
    this.pageType = this.$route.query?.linkType
    this.categoryId = this.$route.query?.categoryId
    this.tabcode = this.$route.query?.tabcode
    this.seccode = this.$route.query?.seccode
    this.fetchData()
  },
  methods: {
    //统一获取数据
    fetchData() {
      if (!this.tabcode) return
      getNavItemByCode(this.tabcode).then((res) => {
        if (!res.data) return
        //侧边栏列表
        this.tabList = res.data[0]

        if (this.tabList.categoryCode == this.categoryId) {
          this.currentCategory = this.tabList
        }
        if (this.currentCategory.categoryName == '') {
          let attr = this.tabList?.list?.filter((p) => {
            if (p.categoryCode == this.categoryId) {
              console.log('categoryName', p.categoryName)
              return p
            }
          })
          if (attr?.length) {
            this.currentCategory = attr[0]
          }
        }
      })
      //获取文章列表
      this.getArticlePage()
    },
    //获取文章列表
    getArticlePage() {
      getArticlePage({
        page: 1,
        limit: 10000,
        categoryCode: this.categoryId
      }).then((res) => {
        console.log(res.data)
        if (!res.data) return
        this.newsList = res.data.list
      })
    }
  }
}
</script>

<style scoped lang="scss">
.match-invite-page {
  display: flex;
  flex-direction: column;

  .collaboration-content {
    display: flex;
    flex-direction: column;
    width: 1340px;
    margin: 34px auto 120px;
    .company-row {
      display: flex;
      flex-direction: row;
      margin-top: 48px;
      .company-message {
        flex: 1;
        display: flex;
        flex-direction: column;
        .message-title {
          height: 60px;
          line-height: 60px;
          color: #1b56a9;
          font-size: 28px;
          font-weight: 600;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
        }
        .desc {
          font-size: 20px;
          color: #333;
          line-height: 35px;
        }
      }
      .company-flex {
        width: 64px;
      }
      .company-image {
        width: 650px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        .image {
          width: 650px;
          height: 428px;
          object-fit: cover;
        }
      }
    }
    .company-row-active {
      flex-direction: row-reverse;
    }
    .company-row:nth-child(n + 2) {
      margin-top: 64px;
    }
    .icon-image {
      width: 362px;
      height: 64px;
      margin: 0 auto 34px;
      object-fit: contain;
    }
  }
}

// 手机端css
.mobile-content {
  .match-invite-page {
    .collaboration-content {
      width: 345px;
      margin: 32px auto 60px;
      .company-row-active {
        flex-direction: column;
      }
      .company-row {
        display: flex;
        flex-direction: column;
        margin-top: 20px;
        .company-message {
          margin-left: 0;

          .message-title {
            line-height: 30px;
            height: 30px;
            font-size: 20px;
            margin-top: 20px;
          }
          .desc {
            font-size: 14px;
            line-height: 24px;
            margin-top: 10px;
          }
        }
        .company-image {
          width: 345px;
          .image {
            width: 345px;
            height: 250px;
          }
        }
      }
      .icon-image {
        width: 250px;
        height: 38.4px;
        margin-bottom: 20px;
      }
    }
  }
}
</style>
